/* global axios */

const API_VERSION = '/api/v2';

class HolidaysAPI {
  constructor() {
    this.apiVersion = API_VERSION;
  }

  getUrl(accountId) {
    return `${this.apiVersion}/accounts/${accountId}/holidays`;
  }

  get(accountId) {
    return axios.get(this.getUrl(accountId));
  }

  create(accountId, data) {
    return axios.post(this.getUrl(accountId), { holiday: data });
  }

  update(accountId, id, data) {
    return axios.patch(`${this.getUrl(accountId)}/${id}`, { holiday: data });
  }

  delete(accountId, id) {
    return axios.delete(`${this.getUrl(accountId)}/${id}`);
  }
}

export default new HolidaysAPI();
